import DashboardLayout from '../../Layout/Index'
import { AddNewUser } from '../../Modals/AddNewUser'
import SettingSideBar from '../../components/sidebar/SettingSideBar'

const Settings = () => {
  return (
    <DashboardLayout>
      <div className="px-6 px-8 py-10 bg-white w-full mt-16">
        <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-[#FF0000] pb-2">Settings</h1>
            <AddNewUser />
          </div>
          <div className="">
            <p className="text-sm lg:w-md text-[#0A0A0ACC]">
              Manage your account settings, update user roles, and customize
              preferences to keep everything running smoothly.
            </p>
        </div>
      <div className="h-[1px] w-full border-0 bg-primaryGray my-2" />
      <SettingSideBar />
    </div>
    </DashboardLayout>
  )
}

export default Settings